export default {
    objective: '',
    achieve: '',
    demonstrate: '',
    completeBy: null,
    completed: false
}